let environmentType,
  backendHost,
  websiteHost,
  primaryAssetHost = "https://omnimages.imgix.net/",
  secondaryAssetHost =
    "https://az742041.vo.msecnd.net/vcsites/vcimages/resource/",
  herokuappHost,
  marketUrl,
  enqAssetHost,
  flutterwaveKey,
  businessDashboardUrl,
  websiteUrl,
  userVconnectUrl,
  paystackKey,
  domainName,
  hostDomain,
  socketUrl,
  facebookApi,
  gmbApiKey,
  gmbClientId,
  gmbApiUrl,
  gmbScope,
  gmbHostUrl,
  freshSalesEndpoint,
  canvaKey,
  mapsApiKey,
  googleKey,
  oranKey,
  microServiceHost,
  sendbirdAppId,
  sendbirdApiToken,
  sendbirdAdminId;

const isBrowser = typeof window !== "undefined";
const self = isBrowser ? window : { location: { hostname: "" } };

const hostname = self && self.location && self.location.hostname;
if (["oms.omnibiz.com", "omslive.omnibiz.com"].includes(hostname)) {
  if (["oms.omnibiz.com"].includes(hostname)) {
    environmentType = "production";
    oranKey = "MzExMTA2VEhVUlNEQVk=";
    hostDomain = "https://oms.omnibiz.com";
  } else if (["omslive.omnibiz.com"].includes(hostname)) {
    environmentType = "production";
    oranKey = "MzExMTA2VEhVUlNEQVk=";
    hostDomain = "https://omslive.omnibiz.com";
  } else {
    environmentType = "prelive";
    oranKey = "9vqTRLw1";
    hostDomain = "https://oms.omnibiz.com";
  }
  websiteHost = "https://livesiteapi.omnibiz.com/api/";
  marketUrl = "https://market.omnibiz.com/";
  enqAssetHost =
    "https://az742041.vo.msecnd.net/vcsites/vcimages/resource/uploads/enquiry/businessquotations/";
  businessDashboardUrl = "https://oms.omnibiz.com";
  websiteUrl = "https://omnibiz.com/";
  userVconnectUrl = "https://vconnect.com/";
  paystackKey = "pk_live_f47c18014e8198b5349f81c85a518dc6f89de7e4";
  flutterwaveKey = "FLWPUBK-2b0b05732c1fc630a877eeb75a6dafad-X";
  socketUrl = "https://notifications.vconnect.com/hub";

  freshSalesEndpoint = "https://freshsales.vconnect.com/api/";
  facebookApi = "https://lfbapi.omnibiz.com/";
  gmbApiKey = "AIzaSyAjWan9aIIkmRGKBWJQfMidRHFuI4vtGmM";
  gmbClientId =
    "910718044851-srv7e4nhv177fjep46b8f4ulqeblmbhp.apps.googleusercontent.com";
  gmbApiUrl = "https://mybusiness.googleapis.com/v4/";
  gmbScope = "https://www.googleapis.com/auth/business.manage";
  gmbHostUrl = "https://gmb.omnibiz.com/gmb/";
  canvaKey = "vq5we8aGtCSxbCq_1lBrP7QS";
  mapsApiKey = "AIzaSyAjWan9aIIkmRGKBWJQfMidRHFuI4vtGmM";
  domainName =
    self.location.hostname === "omniprelive.now.sh"
      ? "omniprelive.now.sh"
      : ".omnibiz.com";

  googleKey = "AIzaSyBl_P29WM3Cx3Z90TZHHBYBn8-0MDl2pyw";
  sendbirdAppId = "05531B32-CC88-42C4-9DF7-645F13ACBA85";
  sendbirdApiToken = "79355fd34e6269be37a417a04788f5007f2740b0";
  sendbirdAdminId = "620695";
} else {
  websiteHost = "https://stagesiteapi.omnibiz.com/api/";
  marketUrl = "https://stagemarket.omnibiz.com/";
  enqAssetHost =
    "https://az742041.vo.msecnd.net/vcsites/vcimages/resource/uploads/enquiry/businessquotations/";
  businessDashboardUrl = "https://pwa.omnibiz.com";
  websiteUrl = "https://stage.omnibiz.com/";
  userVconnectUrl = "http://stage.vconnect.co/";
  // paystackKey = "pk_test_cbf9f3b5a6b630695f5ed212a2fb0ec0f5bd6d2f";
  paystackKey = "pk_test_559a80048e81d9ae74eff1df416e7e80ce5f7db9";
  flutterwaveKey = "FLWPUBK-f7fc6d6497ace8d666f2d2a622b6f3c0-X";
  hostDomain = "https://pwa.omnibiz.com";
  socketUrl = "https://stagenotifications.omnibiz.com/hub";
  environmentType = "development";
  freshSalesEndpoint = "https://freshsales.vconnect.com/api/";
  facebookApi = "https://sfbapi.omnibiz.com/";
  gmbApiKey = "AIzaSyDRRTNm_XE8e0bylEwrh1aWTtuCIh7nifg";
  gmbClientId =
    "910718044851-srv7e4nhv177fjep46b8f4ulqeblmbhp.apps.googleusercontent.com";
  gmbApiUrl = "https://mybusiness.googleapis.com/v4/";
  gmbScope = "https://www.googleapis.com/auth/business.manage";
  gmbHostUrl =
    "https://cors-anywhere.herokuapp.com/https://boapiprelive.vconnect.com/gmb/";
  canvaKey = "fm_BRw2ElKTBLsJrGSepZ4-o";
  mapsApiKey = "AIzaSyDRRTNm_XE8e0bylEwrh1aWTtuCIh7nifg";
  domainName = hostname;
  // googleKey = "AIzaSyDRRTNm_XE8e0bylEwrh1aWTtuCIh7nifg";
  googleKey = "AIzaSyBl_P29WM3Cx3Z90TZHHBYBn8-0MDl2pyw";
  oranKey = "9vqTRLw1";
  sendbirdAppId = "F94B9A6F-6A38-49CC-AE3D-650DA5A5FD0C";
  sendbirdApiToken = "6633a0cdadf8c0ddaeeaa3244a29c6ad8d224ac0";
  sendbirdAdminId = "620695";
}
// herokuappHost = "https://omnicors.herokuapp.com/";
herokuappHost = "";

if (hostname.includes("movam.omnibiz.app")) {
  backendHost = "https://omniapi.omnibiz.app/";
  microServiceHost = "https://api.omnibiz.app";
} else if (hostname.includes("oms-new-movam-uat.surge.sh")) {
  backendHost = "https://uatomsapi.omnibiz.app/";
  microServiceHost = "https://api-uat.omnibiz.app";
} else {
  //  backendHost = "https://devomsapi.omnibiz.app/";
  backendHost = "https://uatomsapi.omnibiz.app/";
  microServiceHost = "https://api-dev.omnibiz.app";
}

export const tracking_url = "https://track.mcpl.ga/api/";
export const tracking_auth_crendentials = {
  username: "mcpllag1",
  password: "12345",
};

export const public_key =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0NW6f5zj4qMuAdVEFB0SOVgaI+c82oC8u/Guri+1yOXvtI203CZWe056U+4omAk2mz3xdVARommvOovdPun9RFXbR0nEZC9qcDUD6VBEm2ZASs2Fm4BXb0C6eBB8szYMaNWdwkJlKXNPxsbHFz+cEr3AwBZsQW25ibM38SXfibqYOUFCzN9E8fixCOyFVNzTrwkePswcsaWTeZ3HSK/CeL/oHo0gdr7/r42ga+Ez7mbmfBDvvnCOIZAY3HR0lR/Ho870Y1yNI7mIdwxmu0xSiXkotzvIBBAQiMLj2DEqWaYB2uX8Z3eQoivttxsPF2bdwb/QE08tXOyDfJVn0Lv92wIDAQAB";
export const encryption_app_key = "SVPV2SPBN";

export const retail_order = "retailorder/";

export const host_url = `${backendHost}api/`,
  website_hosturl = `${websiteHost}`,
  asset_url = `${secondaryAssetHost}`,
  primary_asset_url = `${primaryAssetHost}`,
  herokuapp_url = `${herokuappHost}`,
  website_host = `${websiteHost}`,
  market_url = `${marketUrl}`,
  enqasset_url = `${enqAssetHost}`,
  business_dashboard_url = `${businessDashboardUrl}`,
  website_login = `${websiteUrl}login?rturl=${self.location.href}`,
  website_logout = `${websiteUrl}account/logout?returnUrl=${self.location.origin}/`,
  website_url = `${websiteUrl}`,
  user_vconnect_url = `${userVconnectUrl}`,
  paystack_key = `${paystackKey}`,
  flutterwave_key = `${flutterwaveKey}`,
  domain_name = `${domainName}`,
  host_domain = `${hostDomain}`,
  env_type = `${environmentType}`,
  socket_url = `${socketUrl}`,
  freshsales_api = `${freshSalesEndpoint}`,
  facebook_api = facebookApi,
  facebookID = "1911835115729684",
  twitterID = "0N5Tg9C1909ucKYARriaeSWrr",
  gmb_api_key = `${gmbApiKey}`,
  gmb_api_url = `${gmbApiUrl}`,
  gmb_client_id = `${gmbClientId}`,
  gmb_scope = `${gmbScope}`,
  gmb_host_url = `${gmbHostUrl}`,
  canva_key = `${canvaKey}`,
  maps_api_key = `${mapsApiKey}`,
  google_key = `${googleKey}`,
  oran_key = `${oranKey}`,
  micro_service_host = `${microServiceHost}/`,
  bitly_token = `49881c5ec815f29886922fae1a22985b72d65577`,
  host_api_omni_point = `${microServiceHost}/retailpayment/api/`,
  sendbird_AdminId = `${sendbirdAdminId}`,
  sendbird_id = `${sendbirdAppId}`,
  sendbird_token = `${sendbirdApiToken}`;
